import { useMemo } from 'react';
import type { Jast, TerminalClause } from '@atlaskit/jql-ast';
import { ClauseCollectingVisitor } from '../clause-collecting-visitor/index.tsx';

/**
 * Returns all AST terminal clauses that match the provided field's JQL term (case-insensitive)
 */
export const useClausesForField = (ast: Jast, jqlTerm: string | undefined): TerminalClause[] =>
	useMemo(() => {
		return getClausesForField(ast, jqlTerm);
	}, [ast, jqlTerm]);

/**
 * Returns all AST terminal clauses that match the provided field's JQL term (case-insensitive)
 * A version of useClausesForField that doesn't use useMemo so it can be used in functions
 */
export const getClausesForField = (ast: Jast, jqlTerm: string | undefined): TerminalClause[] => {
	if (!jqlTerm) return [];
	const visitor = new ClauseCollectingVisitor(jqlTerm);
	return ast.query ? visitor.visit(ast.query) : [];
};
